import React from 'react';
import { useIntl } from 'react-intl';
import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import messages from './messages';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

import styles from './styles.cssm';

const UnauthPartnershipCard = ({
  imageUrl,
  imageAlt,
  description,
  learnMoreUrl,
  disclaimerTarget,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={`${styles.cardContainer} flex flex-column items-center justify-around px4 pt4 pb5`}
      data-e2e={`partnership-card-${disclaimerTarget.id}`}
    >
      {imageUrl ? (
        <ImageLoader
          alt={imageAlt || ''}
          className="block"
          height="100"
          role="presentation"
          src={imageUrl}
          width="220"
        />
      ) : null}

      {messages[description] ? (
        <div className="text-xs text-center">
          {formatMessage(messages[description], {
            disclaimerTarget: disclaimerTarget ? (
              <a
                aria-labelledby="disclaimerTitleId"
                className={`text-noUnderline ${styles.target}`}
                href={`#${disclaimerTarget.descriptionId}`}
                id={disclaimerTarget.id}
              >
                <sup>{disclaimerTarget.number}</sup>
              </a>
            ) : null,
          })}
        </div>
      ) : null}
      {learnMoreUrl ? (
        <Button
          data-e2e={`partnership-button-${disclaimerTarget.id}`}
          href={learnMoreUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {formatMessage(sharedCallsToAction.learnMore)}
        </Button>
      ) : null}
    </div>
  );
};

export default UnauthPartnershipCard;
